module.exports = __webpack_public_path__ + "img/H4.81d8dd76.png";